import * as THREE from 'three'

function computeFitDistance(box: THREE.Box3, cam: THREE.PerspectiveCamera): number {
  const sphere = box.getBoundingSphere(new THREE.Sphere())
  const fovV = (cam.fov * Math.PI) / 180
  const fovH = 2 * Math.atan(Math.tan(fovV / 2) * cam.aspect)
  const minFov = Math.min(fovV, fovH)
  return (sphere.radius / Math.sin(minFov / 2)) * 1.1
}

export function computeDefaultOffset(box: THREE.Box3, cam: THREE.PerspectiveCamera): THREE.Vector3 {
  return new THREE.Vector3(1, 1, 1).normalize().multiplyScalar(computeFitDistance(box, cam))
}
